// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"b3f4d0c4","488":"e5271dcb","696":"ef89bbd5"}[chunkId] + ".chunk.js";
};